import Component, { mixins } from 'vue-class-component'
import { OptionApiModel } from '@/interfaces/OptionApiModel'
import { namespace } from 'vuex-class'
import { useOptionStore } from '@/store/modules/options'
import { ConfirmModalData } from '@/interfaces/ConfirmModalData'
import { OptionValidator } from './OptionValidator'
import { OptionSelectionHelper } from '@/helpers/OptionSelectionHelper'
import { ProductApiModel } from '@/interfaces/ProductApiModel'
import { SubOptionType } from '@/interfaces/SubOptionType'
const currentModel = namespace('currentModel')

@Component
export class OptionSelectionMixin extends mixins(OptionValidator) {
  public optionStore = useOptionStore();

  @currentModel.Action
  public toggleUpdating!: (isBeingUpdated: boolean) => void

  @currentModel.Action
  public updateModelProperty!: (payload: { property: string; value: any }) => void

  @currentModel.Action
  public removeModelPropertyOption!: (payload: { property: string; value: string }) => void

  @currentModel.Action
  public addModelPropertyOption!: (payload: { property: string; value: string }) => void

  public getCurrentModelHelper(model: ProductApiModel) {
    return new OptionSelectionHelper(this.toggleUpdating, this.updateModelProperty, this.removeModelPropertyOption, this.addModelPropertyOption, this.showConfirmDeselect, model)
  }

  public async selectOption(optionItem: OptionApiModel, forceDeselection = false): Promise<void> {
    await this.getCurrentModelHelper(this.model).selectOption(optionItem, forceDeselection)
  }

  public selectSubOption(subOptionType: SubOptionType, subOptionItem: OptionApiModel) {
    this.getCurrentModelHelper(this.model).selectSubOption(subOptionType, subOptionItem)
  }

  public async deselectOption(optionItem: OptionApiModel, forceDeselection = false,
    skipDependencies = false) {
    await this.getCurrentModelHelper(this.model).deselectOption(optionItem, forceDeselection, skipDependencies)
  }

  public isOptionSelected(optionItem: OptionApiModel) {
    return this.getCurrentModelHelper(this.model).isOptionSelectedWithModel(optionItem, this.model)
  }

  private showConfirmDeselect(optionItem: OptionApiModel, dependentOptions: OptionApiModel[]): Promise<boolean> {
    return new Promise(resolve => {
      const data = new ConfirmModalData(resolve)
      data.title = 'Remove options?'
      data.question = '<div class="mb-1">Following options depend on \'' + optionItem.name + '\':</div><ul class="mb-0">' +
        dependentOptions.map(o => '<li class="mb-1">' + o.name + '</li>').join('') + '</ul><div>and will be also removed.</div>'
      data.confirmButton = 'CONTINUE'
      this.$root.$emit('openConfirmModal', data)
    })
  }
}
